import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import styles from './styles.scss';

import IconPlay from './play-circle.svg?inline';

const cx = classNames.bind(styles);

export default function GameThumbnail({
  title, url, thumbnailSrc, provider,
}) {
  return (
    <Link to={url} className={cx('thumbnail')}>
      <img src={thumbnailSrc} alt={title} />
      <div className={cx('hover-overlay')}>
        <span>{title}</span>
        <IconPlay />
        <span className={cx('small')}>{provider}</span>
      </div>
    </Link>
  );
}
GameThumbnail.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  thumbnailSrc: PropTypes.string.isRequired,
  provider: PropTypes.string.isRequired,
};
GameThumbnail.defaultProps = {};
